import { push } from "../../../lib/gtm";
var navEvent = "navEvent";
var acmHeader = "ACM Header";
var NavigationType;
(function (NavigationType) {
    NavigationType["Main"] = "Main Navigation";
    NavigationType["Consumer"] = "Consumer Navigation";
    NavigationType["Mobile"] = "Mobile Navigation";
})(NavigationType || (NavigationType = {}));
export var MenuDrawer;
(function (MenuDrawer) {
    MenuDrawer["Open"] = "Open Menu";
    MenuDrawer["Close"] = "Close Menu";
})(MenuDrawer || (MenuDrawer = {}));
export var trackMainNavEvent = function (title, url) {
    push({
        event: navEvent,
        content_type: acmHeader,
        content_list_type: NavigationType.Main,
        content_title: title,
        content_id: url !== null && url !== void 0 ? url : "NA",
    });
};
export var trackSearchEvent = function (keyword) {
    push({
        event: navEvent,
        content_type: acmHeader,
        content_title: keyword,
        content_list_type: "Search",
    });
};
export var trackSubNavEvent = function (title, url) {
    if (url)
        push({
            event: navEvent,
            content_type: acmHeader,
            content_list_type: NavigationType.Consumer,
            content_title: title,
            content_id: url,
        });
};
export var trackMobileNavEvent = function (title, url) {
    push({
        event: navEvent,
        content_type: acmHeader,
        content_list_type: NavigationType.Mobile,
        content_title: title,
        content_id: url !== null && url !== void 0 ? url : "NA",
    });
};
